import React from "react";

import { useLight } from "./hooks";

export const Light = React.memo(() => {
  const { getLightProps } = useLight();
  return <div {...getLightProps()} />;
});

Light.displayName = "Light";
